/*
  House of Zena — Wishlist Subsystem
  Enterprise Hardened & Safe LocalStorage with Global Sync
*/

(function () {
  'use strict';

  const STORAGE_KEY = 'ks-wishlist';

  const WishlistStore = {
    getWishlist: function () {
      try {
        if (typeof window === 'undefined' || !window.localStorage) return [];
        const items = window.localStorage.getItem(STORAGE_KEY);
        return items ? JSON.parse(items) : [];
      } catch (e) {
        return [];
      }
    },

    setWishlist: function (array) {
      try {
        if (typeof window !== 'undefined' && window.localStorage) {
          window.localStorage.setItem(STORAGE_KEY, JSON.stringify(array || []));
        }
      } catch (e) {}
    },

    has: function (url) {
      if (!url) return false;
      const cleanUrl = url.split('?')[0];
      const items = this.getWishlist();
      return items.some(item => (item.url || '').split('?')[0] === cleanUrl);
    },

    updateBadges: function (animate) {
      const items = this.getWishlist();
      const count = items.length;

      document.querySelectorAll('.wishlist-count-badge').forEach(badge => {
        badge.dataset.count = count;
        badge.textContent = count;
        if (animate) {
          badge.classList.remove('badge-pop');
          void badge.offsetWidth; // Trigger reflow for animation restart
          badge.classList.add('badge-pop');
        }
      });

      document.querySelectorAll('.zena-wishlist-header-count').forEach(headerCount => {
        headerCount.textContent = `(${count})`;
      });
    },

    updateButtons: function () {
      const items = this.getWishlist();
      const urls = new Set(items.map(i => (i.url || '').split('?')[0]));

      document.querySelectorAll('wishlist-button, .btn-wishlist, .product-card-wishlist-icon, .zena-ts-wishlist-btn, .zena-bs-wishlist, .zena-sbb-wishlist-btn, .pdp-atc-wishlist-btn').forEach(elem => {
        const card = elem.closest('.zena-sbb-product-card, .zena-ts-card, .zena-bs-card, .product-card, .card, .col, li') || elem;
        let productUrl = elem.dataset.productUrl || elem.getAttribute('data-product-url') || (card.querySelector('a') ? card.querySelector('a').getAttribute('href') : '') || '';
        
        if (!productUrl || productUrl.startsWith('#')) {
          const rawTitle = elem.dataset.productTitle || (card.querySelector('h3, h4, .zena-sbb-title, .zena-ts-title, .product-card-title')?.textContent || '');
          const handle = rawTitle.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
          if (handle) productUrl = '/products/' + handle;
        }

        if (!productUrl) return;

        const cleanUrl = productUrl.split('?')[0];
        const isWishlisted = urls.has(cleanUrl);
        const svg = elem.querySelector('svg');

        if (elem.tagName.toLowerCase() === 'wishlist-button') {
          if (typeof elem.adjustBtn === 'function') {
            elem.adjustBtn();
          }
          return;
        }

        if (isWishlisted) {
          elem.classList.add('active');
          elem.setAttribute('aria-pressed', 'true');
          elem.dataset.active = 'true';
          elem.setAttribute('data-active', 'true');
          if (svg) {
            svg.setAttribute('fill', '#D96B75');
            svg.setAttribute('stroke', '#D96B75');
            svg.style.fill = '#D96B75';
            svg.style.stroke = '#D96B75';
          }
          if (window.theme && window.theme.locales && window.theme.locales.wishlist) {
            elem.setAttribute('aria-label', window.theme.locales.wishlist.remove);
          }
        } else {
          elem.classList.remove('active');
          elem.setAttribute('aria-pressed', 'false');
          elem.dataset.active = 'false';
          elem.setAttribute('data-active', 'false');
          if (svg) {
            svg.setAttribute('fill', 'none');
            svg.setAttribute('stroke', '#7D6656');
            svg.style.fill = 'none';
            svg.style.stroke = '#7D6656';
          }
          if (window.theme && window.theme.locales && window.theme.locales.wishlist) {
            elem.setAttribute('aria-label', window.theme.locales.wishlist.add);
          }
        }
      });
    },

    toggle: async function (url, productData) {
      if (!url) return;
      const cleanUrl = url.split('?')[0];
      let items = this.getWishlist();
      const existingIndex = items.findIndex(i => (i.url || '').split('?')[0] === cleanUrl);

      if (existingIndex > -1) {
        items.splice(existingIndex, 1);
      } else {
        const newItem = {
          url: cleanUrl,
          id: productData?.id || Date.now(),
          variant_id: productData?.variant_id || productData?.id || null,
          handle: productData?.handle || cleanUrl.split('/').pop(),
          title: productData?.title || 'Demi-Fine Jewelry Piece',
          img_src: productData?.featured_image || productData?.img_src || '',
          img_alt: productData?.title || 'Demi-Fine Jewelry Piece',
          compare_at_price: productData?.compare_at_price || 0,
          price: productData?.price || 0,
          price_varies: productData?.price_varies || false,
          added_at: Date.now()
        };
        items.push(newItem);

        // Enrich product data asynchronously in the background if not provided
        if (!productData || !productData.featured_image || !newItem.variant_id) {
          fetch(`${cleanUrl}.js`)
            .then(res => res.ok ? res.json() : null)
            .then(data => {
              if (data) {
                const current = WishlistStore.getWishlist();
                const idx = current.findIndex(i => (i.url || '').split('?')[0] === cleanUrl);
                if (idx > -1) {
                  current[idx] = {
                    ...current[idx],
                    id: data.id,
                    variant_id: data.variants && data.variants[0] ? data.variants[0].id : data.id,
                    handle: data.handle,
                    title: data.title,
                    img_src: data.featured_image,
                    img_alt: data.featured_image?.alt || data.title,
                    compare_at_price: data.compare_at_price,
                    price: data.price,
                    price_varies: data.price_varies
                  };
                  WishlistStore.setWishlist(current);
                  const container = document.querySelector('wishlist-container');
                  if (container && typeof container.setContent === 'function') {
                    container.setContent();
                  }
                }
              }
            })
            .catch(() => {});
        }
      }

      this.setWishlist(items);
      this.updateBadges(true);
      this.updateButtons();

      const container = document.querySelector('wishlist-container');
      if (container && typeof container.setContent === 'function') {
        container.setContent();
      }

      window.dispatchEvent(new CustomEvent('kt.wishlist.updated', {
        detail: { count: items.length, items: items }
      }));
      window.dispatchEvent(new CustomEvent('zena:wishlist:changed', {
        detail: { count: items.length, items: items }
      }));
    },

    addItemToCart: async function (variantId, productUrl, btnEl) {
      if (!variantId && !productUrl) return;

      // 1. Instant Drawer Transition (0ms latency): Close Wishlist & Open Cart immediately
      const wishlistOffcanvasEl = document.getElementById('offcanvas-wishlist');
      if (wishlistOffcanvasEl && window.bootstrap?.Offcanvas) {
        window.bootstrap.Offcanvas.getInstance(wishlistOffcanvasEl)?.hide();
      }

      const cartContainer = document.querySelector('cart-container');
      if (cartContainer && typeof cartContainer.openCartDrawer === 'function') {
        cartContainer.openCartDrawer();
      } else {
        const cartOffcanvasEl = document.getElementById('offcanvas-cart');
        if (cartOffcanvasEl && window.bootstrap?.Offcanvas) {
          window.bootstrap.Offcanvas.getOrCreateInstance(cartOffcanvasEl).show();
        } else {
          document.querySelector('[data-bs-target="#offcanvas-cart"]')?.click();
        }
      }

      // 2. Optimistically bump cart count badge immediately
      document.querySelectorAll('.cart-count-badge').forEach(elem => {
        const current = parseInt(elem.dataset.count || elem.textContent, 10) || 0;
        elem.textContent = current + 1;
        elem.dataset.count = current + 1;
        elem.classList.add('badge-bump');
        setTimeout(() => elem.classList.remove('badge-bump'), 400);
      });

      // 3. Remove from wishlist immediately
      if (productUrl) {
        this.toggle(productUrl);
      }

      // 4. Background network dispatch
      try {
        let finalVariantId = variantId;
        if (!finalVariantId && productUrl) {
          const cleanUrl = productUrl.split('?')[0];
          const prodRes = await fetch(`${cleanUrl}.js`);
          if (prodRes.ok) {
            const prodData = await prodRes.json();
            finalVariantId = prodData.variants && prodData.variants[0] ? prodData.variants[0].id : prodData.id;
          }
        }

        if (!finalVariantId) return;

        if (cartContainer && typeof cartContainer.add === 'function') {
          await cartContainer.add({ items: [{ id: finalVariantId, quantity: 1 }] });
        } else {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: finalVariantId, quantity: 1, sections: 'cart-count-badge,offcanvas-cart' })
          });
          if (res.ok) {
            const data = await res.json();
            if (data.sections && cartContainer) {
              cartContainer.reloadCartElements(data.sections);
            }
            window.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
            window.dispatchEvent(new CustomEvent('kt.cart.updated', { detail: data }));
          }
        }
      } catch (err) {
        if (typeof window.zenaLog === 'function') window.zenaLog('error', 'Wishlist ATC failed', err);
      }
    },

    moveAllToCart: async function (btnEl) {
      const items = this.getWishlist();
      if (!items.length) return;

      // 1. Instant Drawer Transition (0ms latency): Close Wishlist & Open Cart immediately
      const wishlistOffcanvasEl = document.getElementById('offcanvas-wishlist');
      if (wishlistOffcanvasEl && window.bootstrap?.Offcanvas) {
        window.bootstrap.Offcanvas.getInstance(wishlistOffcanvasEl)?.hide();
      }

      const cartContainer = document.querySelector('cart-container');
      if (cartContainer && typeof cartContainer.openCartDrawer === 'function') {
        cartContainer.openCartDrawer();
      } else {
        const cartOffcanvasEl = document.getElementById('offcanvas-cart');
        if (cartOffcanvasEl && window.bootstrap?.Offcanvas) {
          window.bootstrap.Offcanvas.getOrCreateInstance(cartOffcanvasEl).show();
        } else {
          document.querySelector('[data-bs-target="#offcanvas-cart"]')?.click();
        }
      }

      // 2. Optimistically bump cart count badge immediately
      document.querySelectorAll('.cart-count-badge').forEach(elem => {
        const current = parseInt(elem.dataset.count || elem.textContent, 10) || 0;
        elem.textContent = current + items.length;
        elem.dataset.count = current + items.length;
        elem.classList.add('badge-bump');
        setTimeout(() => elem.classList.remove('badge-bump'), 400);
      });

      // 3. Clear Wishlist immediately
      this.setWishlist([]);
      this.updateBadges(true);
      this.updateButtons();

      // 4. Resolve all variant IDs in PARALLEL via Promise.all
      try {
        const itemsToAdd = await Promise.all(items.map(async (item) => {
          let vId = item.variant_id;
          if (!vId && item.url) {
            try {
              const res = await fetch(`${item.url}.js`);
              if (res.ok) {
                const prod = await res.json();
                vId = prod.variants && prod.variants[0] ? prod.variants[0].id : prod.id;
              }
            } catch (e) {}
          }
          return vId ? { id: vId, quantity: 1 } : null;
        }));

        const validItems = itemsToAdd.filter(Boolean);

        if (validItems.length) {
          if (cartContainer && typeof cartContainer.add === 'function') {
            await cartContainer.add({ items: validItems });
          } else {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: validItems, sections: 'cart-count-badge,offcanvas-cart' })
            });
            if (res.ok) {
              const data = await res.json();
              if (data.sections && cartContainer) {
                cartContainer.reloadCartElements(data.sections);
              }
              window.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
              window.dispatchEvent(new CustomEvent('kt.cart.updated', { detail: data }));
            }
          }
        }
      } catch (err) {
        if (typeof window.zenaLog === 'function') window.zenaLog('error', 'Move all to cart failed', err);
      }
    }
  };

  window.ZenaWishlist = WishlistStore;

  // Universal Global Wishlist Toggle Function for all sections
  window.zenaToggleWishlist = function (btn, productId) {
    if (!btn) return;
    const card = btn.closest('.zena-sbb-product-card, .zena-ts-card, .zena-bs-card, .product-card, .card, .col, li') || btn;
    
    // Find URL
    let productUrl = btn.dataset.productUrl || (card.querySelector('a') ? card.querySelector('a').getAttribute('href') : '') || '';
    if (!productUrl || productUrl.startsWith('#')) {
      const rawTitle = btn.dataset.productTitle || (card.querySelector('h3, h4, .zena-sbb-title, .zena-ts-title, .product-card-title')?.textContent || 'item');
      const handle = rawTitle.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
      productUrl = '/products/' + (handle || 'demi-fine-jewelry');
    }

    // Find Title
    const title = btn.dataset.productTitle || (card.querySelector('h3, h4, .zena-sbb-title, .zena-ts-title, .product-card-title')?.textContent?.trim()) || 'Demi-Fine Jewelry Piece';
    
    // Find Image
    const imgEl = card.querySelector('img');
    const imgSrc = btn.dataset.productImg || (imgEl ? (imgEl.currentSrc || imgEl.src) : '') || '';
    
    // Find Prices
    const parsePriceNumber = (txt) => {
      if (!txt) return 0;
      const num = parseFloat(txt.replace(/[^0-9.]/g, ''));
      if (isNaN(num)) return 0;
      return num < 10000 ? num * 100 : num;
    };
    
    const priceText = card.querySelector('.zena-sbb-price-sale, .zena-ts-price-sale, .product-price-final, .product-card-price-final')?.textContent || '';
    const compareText = card.querySelector('.zena-sbb-price-compare, .zena-ts-price-compare, .product-card-price-compare')?.textContent || '';
    const price = btn.dataset.productPrice ? Number(btn.dataset.productPrice) : parsePriceNumber(priceText);
    const comparePrice = btn.dataset.productCompare ? Number(btn.dataset.productCompare) : parsePriceNumber(compareText);
    const variantId = btn.dataset.variantId || null;

    WishlistStore.toggle(productUrl, {
      id: productId || Date.now(),
      variant_id: variantId,
      title: title,
      url: productUrl,
      featured_image: imgSrc,
      img_src: imgSrc,
      price: price || 159900,
      compare_at_price: comparePrice || 199900
    });
  };

  // Web Component: <wishlist-container>
  class Wishlist extends HTMLElement {
    constructor () {
      super();
    }

    connectedCallback () {
      WishlistStore.updateBadges(false);
      this.setContent();
    }

    get wishlist () {
      return WishlistStore.getWishlist();
    }

    set wishlist (array) {
      WishlistStore.setWishlist(array);
    }

    async setProduct (url) {
      await WishlistStore.toggle(url);
    }

    setCountBadges () {
      WishlistStore.updateBadges(false);
    }

    setContent () {
      const emptyEl = this.querySelector('.wishlist-empty');
      const listEl = this.querySelector('.wishlist-product-list');
      const footerEl = this.querySelector('.zena-wishlist-footer');
      const items = WishlistStore.getWishlist();

      if (items.length) {
        emptyEl?.setAttribute('hidden', 'hidden');
        footerEl?.removeAttribute('hidden');

        let productList = '';
        const escapeHtml = (str) => {
          if (!str) return '';
          return String(str).replace(/[&<>"']/g, (m) => ({
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#039;'
          })[m]);
        };

        const formatPrice = (p) => {
          if (p == null || p === '') return '₹0.00';
          const numeric = typeof p === 'number' ? p : parseFloat(String(p).replace(/[^0-9.]/g, ''));
          if (isNaN(numeric)) return '₹0.00';
          const rupeeVal = numeric > 10000 ? numeric / 100 : numeric;
          return '₹' + rupeeVal.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        };

        items.forEach(product => {
          const safeTitle = escapeHtml(product.title || 'Demi-Fine Jewelry Piece');
          const safeUrl = encodeURI(product.url || '');
          const imgSrc = product.img_src || '/assets/hero-indian-model-1.jpg';
          const variantId = product.variant_id || product.id || '';

          productList += `
            <li class="wishlist-product-item cart-item" data-product-url="${safeUrl}">
              <div class="d-flex align-items-center gap-3 position-relative">
                <a href="${safeUrl}" class="cart-item-thumb-link flex-shrink-0" tabindex="-1">
                  <img 
                    src="${imgSrc}" 
                    alt="${safeTitle}" 
                    width="72" 
                    height="72" 
                    class="img-fluid object-fit-cover rounded" 
                    loading="lazy">
                </a>
                <div class="flex-grow-1 min-w-0">
                  <div class="d-flex justify-content-between align-items-start gap-2">
                    <h3 class="cart-item-product-title mb-1">
                      <a href="${safeUrl}" class="text-decoration-none">${safeTitle}</a>
                    </h3>
                    <button 
                      type="button" 
                      class="wishlist-item-remove-btn flex-shrink-0" 
                      aria-label="Remove item" 
                      data-product-url="${safeUrl}">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                      </svg>
                    </button>
                  </div>
                  <div class="d-flex align-items-center justify-content-between mt-2 pt-1">
                    <div class="cart-item-price-col d-flex align-items-baseline">
                      <span class="product-price-final">${formatPrice(product.price)}</span>
                      ${product.compare_at_price > product.price ? `<span class="product-price-compare">${formatPrice(product.compare_at_price)}</span>` : ''}
                    </div>
                    <button 
                      type="button" 
                      class="zena-wishlist-item-atc-btn"
                      data-product-url="${safeUrl}"
                      data-variant-id="${variantId}">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                        <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
                        <line x1="3" y1="6" x2="21" y2="6"></line>
                        <path d="M16 10a4 4 0 0 1-8 0"></path>
                      </svg>
                      <span>ADD TO CART</span>
                    </button>
                  </div>
                </div>
              </div>
            </li>
          `;
        });

        if (listEl) {
          listEl.innerHTML = productList;
          listEl.removeAttribute('hidden');

          // Bind single item remove buttons
          listEl.querySelectorAll('.wishlist-item-remove-btn').forEach(removeBtn => {
            removeBtn.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              WishlistStore.toggle(removeBtn.dataset.productUrl);
            });
          });

          // Bind single item ATC buttons
          listEl.querySelectorAll('.zena-wishlist-item-atc-btn').forEach(atcBtn => {
            atcBtn.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              WishlistStore.addItemToCart(atcBtn.dataset.variantId, atcBtn.dataset.productUrl, atcBtn);
            });
          });
        }

        // Bind Move All to Cart button
        const moveAllBtn = this.querySelector('.zena-wishlist-move-all-btn');
        if (moveAllBtn && !moveAllBtn._boundClick) {
          moveAllBtn._boundClick = (e) => {
            e.preventDefault();
            WishlistStore.moveAllToCart(moveAllBtn);
          };
          moveAllBtn.addEventListener('click', moveAllBtn._boundClick);
        }
      } else {
        emptyEl?.removeAttribute('hidden');
        footerEl?.setAttribute('hidden', 'hidden');
        if (listEl) {
          listEl.innerHTML = '';
          listEl.setAttribute('hidden', 'hidden');
        }
      }
    }
  }

  if (!customElements.get('wishlist-container')) {
    customElements.define('wishlist-container', Wishlist);
  }

  // Web Component: <wishlist-button>
  class WishlistButton extends HTMLElement {
    constructor () {
      super();
    }

    connectedCallback () {
      this.btn = this.querySelector('button') || this;
      this.adjustBtn();

      if (!this._boundClick) {
        this._boundClick = async (event) => {
          event.preventDefault();
          event.stopPropagation();
          const url = this.dataset.productUrl || this.getAttribute('data-product-url');
          if (url) {
            await WishlistStore.toggle(url);
          }
        };
        this.addEventListener('click', this._boundClick);
      }
    }

    adjustBtn () {
      const btn = this.querySelector('button') || this;
      if (!btn) return;

      const url = this.dataset.productUrl || this.getAttribute('data-product-url');
      const isWishlisted = WishlistStore.has(url);

      if (isWishlisted) {
        btn.classList.add('active');
        btn.setAttribute('aria-pressed', 'true');
        btn.setAttribute('data-active', 'true');
        if (window.theme && window.theme.locales && window.theme.locales.wishlist) {
          btn.setAttribute('aria-label', window.theme.locales.wishlist.remove);
        }
      } else {
        btn.classList.remove('active');
        btn.setAttribute('aria-pressed', 'false');
        btn.setAttribute('data-active', 'false');
        if (window.theme && window.theme.locales && window.theme.locales.wishlist) {
          btn.setAttribute('aria-label', window.theme.locales.wishlist.add);
        }
      }
    }
  }

  if (!customElements.get('wishlist-button')) {
    customElements.define('wishlist-button', WishlistButton);
  }

  // Delegated click listener as bulletproof fail-safe for all wishlist buttons
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.zena-ts-wishlist-btn, .zena-bs-wishlist, .btn-wishlist, .product-card-wishlist-icon');
    if (btn) {
      const onclickAttr = btn.getAttribute('onclick');
      if (!onclickAttr || !onclickAttr.includes('zenaToggleWishlist')) {
        e.preventDefault();
        e.stopPropagation();
        window.zenaToggleWishlist(btn);
      }
    }
  });

  // Re-sync on tab switch or DOM updates
  document.addEventListener('shown.bs.tab', function () {
    WishlistStore.updateButtons();
  });

  // Sync across browser tabs
  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) {
      WishlistStore.updateBadges(false);
      WishlistStore.updateButtons();
      const container = document.querySelector('wishlist-container');
      if (container && typeof container.setContent === 'function') {
        container.setContent();
      }
    }
  });

  // Initial synchronization on boot
  function initWishlistSync () {
    WishlistStore.updateBadges(false);
    WishlistStore.updateButtons();
    const container = document.querySelector('wishlist-container');
    if (container && typeof container.setContent === 'function') {
      container.setContent();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistSync);
  } else {
    initWishlistSync();
  }

  window.addEventListener('shopify:section:load', initWishlistSync);
  window.addEventListener('kt.collection.loaded', initWishlistSync);

  // Cross-tab wishlist sync: when wishlist changes in another tab, update UI here
  window.addEventListener('storage', (e) => {
    if (e.key === STORAGE_KEY) {
      WishlistStore.updateBadges(false);
      WishlistStore.updateButtons();
    }
  });
})();
